<script>
export default {
    props: {
        //扩展组标识
        groupFlg: {
            type: String
        },
        //扩展元素值
        elementValue: {},
        /* 显示名称宽度设置 */
        labelWidth: {
            type: String,
            default: function() {
                return '80px';
            }
        },
        value: {
            type: Object,
            default: function() {
                return {};
            }
        }
    },
    //动态修改扩展信息对象列表
    inject: ['tdDynamicObjList'],
    watch: {
        /* 监听数据的变化，实时生效 */
        groupFlg() {
            this.rowList = [];
            this.initGroup();
        },
        value: {
            handler(newValue) {
                this.formInfo = newValue;
                for (let val in this.formInfo) {
                    if (this.formInfo[val] == undefined) {
                        this.formInfo[val] = '';
                    }
                    if (this.$util.isEmpty(this.formInfo[val]) || this.$util.isEmpty(this.$refs.dynamicForm)) {
                        continue;
                    } else {
                        for (const columnList of this.rowList) {
                            for (const column of columnList) {
                                if (column.keyName == val && column.props.value != this.formInfo[val]) {
                                    column.props.value = this.formInfo[val];
                                    break;
                                }
                            }
                        }
                        this.$refs.dynamicForm.model[val] = this.formInfo[val];
                    }
                }
            },
            deep: true,
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: false
        }
    },
    data() {
        return {
            formInfo: this.value,
            rowList: [],
            rules: [{ required: true, message: '', trigger: 'change' }, { min: 0, max: 0, message: '', trigger: 'change' }, { pattern: '', message: '' }, { validator: '', trigger: 'change' }]
        };
    },
    created() {
        // 初始化数据
        this.initGroup();
    },
    methods: {
        resetFormFields() {
            this.rowList = [];
            this.$refs.dynamicForm.resetFields();
            this.initGroup();
        },
        // 设置组件的显隐
        /*
            keyName: 组件关键字
            style:组件样式
        */
        setStyle(keyName, style) {
            for (const row of this.rowList) {
                for (const component of row) {
                    if (component.keyName == keyName) {
                        if (this.$util.isEmpty(component.style)) {
                            this.$set(component, 'style', style);
                        } else {
                            component.style = style;
                        }
                        //若隐藏组件，需将控件的必填项校验去掉
                        if (component.style.hasOwnProperty('display') && component.rules.length > 0) {
                            for (let i = 0; i < component.rules.length; i++) {
                                if (component.rules[i].hasOwnProperty('required')) {
                                    if (component.style.display == 'none') {
                                        component.rules[i].required = false;
                                    } else {
                                        component.rules[i].required = true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        // 设置组件的属性
        /*
            propName: 组件属性
            value:属性值
            例：propName = disabled
                value = true
        */
        setProps(keyName, propName, value) {
            for (const row of this.rowList) {
                for (const component of row) {
                    if (component.keyName == keyName) {
                        if (this.$util.isEmpty(component.props[propName])) {
                            this.$set(component.props, propName, value);
                        } else {
                            component.props[propName] = value;
                        }
                        if (propName == 'value') {
                            this.formInfo[keyName] = value;
                        }
                    }
                }
            }
        },
        initGroup() {
            // 初始化数据
            let groupFlg = this.groupFlg;
            if (this.$util.isEmpty(groupFlg)) {
                console.debug('------TdDynamic--groupFlg为空');
                return;
            }
            let param = {
                groupFlg: groupFlg,
                elementValue: this.elementValue
            };
            this.$api.queryExtendInfo(JSON.stringify(param), response => {
                if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                    if (!this.$util.isEmpty(response.data.content)) {
                        this.dealData(JSON.parse(response.data.content));
                    }
                }
            });
        },
        // 提供数据参数
        getfromInfo() {
            return this.formInfo;
        },
        parentMethod(parent, method, event) {
            if (parent) {
                if (parent[method]) {
                    parent[method](event);
                } else {
                    return this.parentMethod(parent.$parent, method, event);
                }
            }
        },
        dealData(componentList) {
            var span = 0;
            for (const component of componentList) {
                // 防止添加组件后v-model没有新加属性值
                // 父组件初始化值
                if (this.$util.isEmpty(this.formInfo[component.keyName])) {
                    this.$set(this.formInfo, component.keyName, component.props.value);
                } else {
                    if (!this.$util.isEmpty(component.props.value)) {
                        this.$set(component.props, 'value', this.formInfo[component.keyName]);
                    } else {
                        component.props.value = this.formInfo[component.keyName];
                    }
                }
                //控件是否隐藏
                let displayValue = '';
                if (component.hidden) {
                    displayValue = 'none';
                }
                let displayObj = { display: displayValue };
                if (this.$util.isEmpty(component.style)) {
                    this.$set(component, 'style', displayObj);
                } else {
                    if (this.$util.isEmpty(component.style.display)) {
                        this.$set(component.style, 'display', displayValue);
                    } else {
                        component.style.display = displayValue;
                    }
                }
                // 拼接校验规则
                var rules = [];
                // 必填校验
                if (component.required) {
                    let notNullHead = this.$t('common.PLEASE_INPUT');
                    if (component.type.indexOf('Tree') != -1 || component.type.indexOf('Select') != -1 || component.type.indexOf('Date') != -1) {
                        notNullHead = this.$t('common.PLEASE_SELECT');
                    }
                    let required = this.$util.clone(this.rules[0]);
                    required.message = notNullHead + component.label;
                    rules.push(required);
                }
                // 长度校验
                if (component.LengthLimit) {
                    let LengthLimit = this.$util.clone(this.rules[1]);
                    LengthLimit.min = component.min;
                    LengthLimit.max = component.max;
                    LengthLimit.message = component.LengthLimitMessage;
                    rules.push(LengthLimit);
                }
                // 正则校验
                if (!this.$util.isEmpty(component.patternRuler)) {
                    let pattern = this.$util.clone(this.rules[2]);
                    pattern.pattern = component.patternRuler;
                    pattern.message = component.patternMessage;
                    rules.push(pattern);
                }
                //自定义校验
                if (!this.$util.isEmpty(component.customRulesMethod)) {
                    let _this1 = this;
                    var customRules = (rule, value, callback) => {
                        this.parentMethod(_this1.$parent, component.customRulesMethod, { rule, value, callback });
                    };
                    let custom = this.$util.clone(this.rules[3]);
                    custom.validator = customRules;
                    rules.push(custom);
                }
                component.rules = rules;
                // 动态修改扩展信息样式
                if (this.$util.isArray(this.tdDynamicObjList)) {
                    let deleteFlag = false;
                    for (const dynamicObj of this.tdDynamicObjList) {
                        deleteFlag = false;
                        if (this.$util.isEmpty(dynamicObj.keyName)) {
                            break;
                        }
                        if (component.keyName == dynamicObj.keyName) {
                            if (this.$util.isEmpty(dynamicObj.operateType)) {
                                break;
                            }
                            //删除数据
                            if (dynamicObj.operateType === 1) {
                                deleteFlag = true;
                                continue;
                            }
                            //修改数据
                            if (dynamicObj.operateType === 0) {
                                if (dynamicObj.styleObj) {
                                    if (this.$util.isEmpty(component.style)) {
                                        this.$set(component, 'style', dynamicObj.styleObj);
                                    } else {
                                        component.style = dynamicObj.styleObj;
                                    }
                                    if (component.style.hasOwnProperty('display') && component.rules.length > 0) {
                                        for (let i = 0; i < component.rules.length; i++) {
                                            if (component.rules[i].hasOwnProperty('required')) {
                                                if (component.style.display == 'none') {
                                                    component.rules[i].required = false;
                                                } else {
                                                    component.rules[i].required = true;
                                                }
                                            }
                                        }
                                    }
                                }
                                if (Array.isArray(dynamicObj.propsObjList)) {
                                    for (const propsObj of dynamicObj.propsObjList) {
                                        if (!this.$util.isEmpty(propsObj.propsName) && !this.$util.isEmpty(propsObj.propsValue)) {
                                            if (this.$util.isEmpty(component.props[propsObj.propsName])) {
                                                this.$set(component.props, propsObj.propsName, propsObj.propsValue);
                                            } else {
                                                component.props[propsObj.propsName] = propsObj.propsValue;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (deleteFlag) {
                        continue;
                    }
                }
                // 注册回调事件
                let events = {};
                var _this = this;
                //子组件的input事件
                events.input = event => {
                    if (event !== undefined) {
                        _this.formInfo[component.keyName] = event;
                        //触发父组件的input事件，将值传给父组件
                        _this.$emit('input', this.formInfo);
                    }
                };
                if (this.$util.isArray(component.events)) {
                    for (const eventInfo of component.events) {
                        events[eventInfo.event] = (...event) => {
                            this.parentMethod(this.$parent, eventInfo.method, event);
                        };
                    }
                }
                this.$set(component, 'on', events);
                // 该组件需要的空间
                span = component.iColNum;
                // 最后一行剩余空间
                var obj = this.rowList[this.rowList.length - 1];
                if (this.$util.isEmpty(obj)) {
                    let list = [];
                    list.push(component);
                    this.rowList.push(list);
                    continue;
                }
                var allSpan = 0;
                for (var j = 0; j < obj.length; j++) {
                    allSpan += obj[j].iColNum;
                }
                if (24 - allSpan >= span) {
                    obj.push(component);
                    this.rowList.splice(this.rowList.length - 1, 1, obj);
                } else {
                    let list = [];
                    list.push(component);
                    this.rowList.push(list);
                }
            }
        }
    },
    render: function(createElement) {
        if (this.rowList.length == 0) {
            return;
        }
        var that = this;
        return createElement(
            'el-form',
            {
                style: { 'margin-bottom': '0px', 'padding-top': '0px' },
                props: {
                    model: that.value,
                    labelPosition: 'right',
                    labelWidth: this.labelWidth
                },
                ref: 'dynamicForm'
            },
            that.rowList.map(function(row, i) {
                return row.map(function(component, j) {
                    return createElement(
                        'el-col',
                        {
                            props: {
                                span: component.iColNum
                            }
                        },
                        [
                            createElement(
                                'el-form-item',
                                {
                                    style: {
                                        display: component.style != undefined && component.style.display !== undefined ? component.style.display : ';'
                                    },
                                    props: {
                                        prop: component.keyName,
                                        label: component.showLabel === true ? component.label : '',
                                        rules: component.rules
                                    }
                                },
                                [
                                    createElement(
                                        component.type,
                                        {
                                            key: j,
                                            style: component.style,
                                            props: component.props,
                                            on: component.on,
                                            ref: component.keyName
                                        },
                                        component.type === 'TdCheckbox' && component.showLabel === true ? '' : component.label
                                    )
                                ]
                            )
                        ]
                    );
                });
            })
        );
    }
};
</script>
<style scoped>
.el-form-item >>> .el-radio,
.el-radio__input {
    line-height: 40px;
}
>>> .el-switch {
    line-height: 40px;
}
>>> .el-switch__label {
    line-height: 40px;
    height: 40px;
}
>>> .el-input-number {
    display: block;
}
.treeDiv >>> .tree-header {
    padding-top: 0px;
}
.treeDiv >>> .inputDiv .conshow {
    margin-top: 0px;
    margin-left: 0px;
}
</style>
